export interface ProgressSaveState {
  unitId: string;
  courseId: string;
  chapterId: string;
  resourceId: string;
  attemptStatus: string;
  resourceType: string;
  lastViewedChapter: string;
  lastViewedUnit: string;
}

interface ProgressResourceState {
  resourceType: string;
  attemptStatus: string;
  resourceId: string;
}

export interface ProgressChapterState {
  chapterId: string;
  chapterProgressPercentage: string;
  resources: ProgressResourceState[];
}

interface ProgressUnitState {
  chapterId: string;
  unitProgressPercentage: string;
  unitId: string;
  chapterProgress: ProgressChapterState[];
}

interface ProgressCourseState {
  unitId: string;
  chapterId: string;
  resourceId: string;
}

export interface ProgressState {
  id?: string;
  createdDate: number;
  lastModifiedDate: number;
  courseId: string;
  userId: string;
  lastViewedChapter: string | null;
  lastViewUpdate: boolean;
  lastViewedUnit: string | null;
  unitProgress: ProgressUnitState[] | null;
  courseProgressPercentage: string;
  courseState: ProgressCourseState | null;
}

// interface ProgressState {
//   progress: ProgressCourseState[];
// }

export const ProgressInitialState: ProgressState = {
  createdDate: 0,
  lastModifiedDate: 0,
  courseId: '',
  userId: '',
  unitProgress: null,
  courseProgressPercentage: '0',
  courseState: null,
  lastViewedChapter: null,
  lastViewUpdate: false,
  lastViewedUnit: null,
};
